/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { AxiosRequestConfig } from 'axios';

import { getSessionAuthHeaders } from './auth-headers';

export function getFullRequestUrl(config: AxiosRequestConfig): string {
  return `${config.baseURL || ''}${config.url || ''}`;
}

export function applySessionAuthHeaders(config: AxiosRequestConfig): void {
  try {
    if (!config.headers) {
      config.headers = {};
    }
    const auth = getSessionAuthHeaders(getFullRequestUrl(config));
    if (
      auth.Authorization !== undefined &&
      config.headers.Authorization === undefined
    ) {
      config.headers.Authorization = auth.Authorization;
    }
    if (auth.TenantId !== undefined && config.headers.TenantId === undefined) {
      config.headers.TenantId = auth.TenantId;
    }
  } catch (error) {
    void error;
  }
}
